import { render } from "./Download.vue?vue&type=template&id=cd1e1506"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/themes/default/resources/app/vue/components/DownloadCenter/Download.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cd1e1506"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cd1e1506', __exports__)) {
    api.reload('cd1e1506', __exports__)
  }
  
  module.hot.accept("./Download.vue?vue&type=template&id=cd1e1506", () => {
    api.rerender('cd1e1506', render)
  })

}


export default __exports__